import React from "react";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";
import { safeGetItem } from "../../utils/localStorageUtils";

export const TableHeadComponent = ({
  titlesArray,
  backgroundColor,
}: {
  titlesArray: any;
  backgroundColor?: string;
}) => {
  const siteInfo = safeGetItem<any>("siteInfo", null);
  return (
    <TableHead
      sx={{
        backgroundColor: `${backgroundColor} !important`,
        "& .MuiTableCell-head": {
          backgroundColor: `${backgroundColor} !important`,
          position: "sticky",
          top: 0,
          zIndex: 1,
        },
      }}
    >
      <TableRow sx={{ backgroundColor: backgroundColor }}>
        {titlesArray.map((title: any, index: number) => {
          return (
            <React.Fragment key={`${title}-${index}`}>
              <TableCell
                align="left"
                sx={{
                  fontFamily: "Mulish",
                  fontWeight: "Bold",
                  backgroundColor: `${backgroundColor} !important`,
                }}
              >
                {title}
                &nbsp;
                {title === "Arm Time" || title === "Disarm Time" ? (
                  <Tooltip
                    title={siteInfo?.timezone ?? ""}
                    placement="top"
                    sx={{ fontSize: "15px", fontFamily: "mulish" }}
                  >
                    <InfoOutlinedIcon fontSize="small"></InfoOutlinedIcon>
                  </Tooltip>
                ) : (
                  ""
                )}
                {title === "Bold Alarm Type" ? (
                  <Tooltip
                    title={
                      "Alarm type for alert, default is BA (Burglary alarm)."
                    }
                    placement="top"
                    sx={{ fontSize: "15px", fontFamily: "mulish" }}
                  >
                    <InfoOutlinedIcon fontSize="small"></InfoOutlinedIcon>
                  </Tooltip>
                ) : (
                  ""
                )}
                {title === "LOITERING TIME" ? (
                  <Tooltip
                    title="The number of seconds an object must be continuously tracked before it is considered a loiterer. An alert will only be triggered once this loitering duration is met."
                    placement="top"
                    sx={{ fontSize: "15px", fontFamily: "mulish" }}
                  >
                    <InfoOutlinedIcon fontSize="small"></InfoOutlinedIcon>
                  </Tooltip>
                ) : (
                  ""
                )}
                {title === "All Metric Emails" ||
                title === "All Metric Notifications" ? (
                  <Tooltip
                    title="Receives instant alerts for all enabled metrics below."
                    placement="top"
                    sx={{ fontSize: "15px", fontFamily: "mulish" }}
                  >
                    <InfoOutlinedIcon fontSize="small"></InfoOutlinedIcon>
                  </Tooltip>
                ) : (
                  ""
                )}
              </TableCell>
            </React.Fragment>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export const TooltipTableHeadComponent = ({
  titlesArray,
  toolTipText,
}: {
  titlesArray: any;
  toolTipText: any;
}) => {
  return (
    <TableHead>
      <TableRow>
        {titlesArray.map((array: any, index: number) => {
          return (
            <React.Fragment key={`${array[1]}-${index}`}>
              <TableCell
                align="left"
                sx={{ fontFamily: "Mulish", fontWeight: "Bold" }}
              >
                {array[0]}
                &nbsp;
                {toolTipText[array[1]] && (
                  <Tooltip
                    title={toolTipText[array[1]]}
                    placement="top"
                    sx={{ fontSize: "15px", fontFamily: "mulish" }}
                  >
                    <InfoOutlinedIcon fontSize="small"></InfoOutlinedIcon>
                  </Tooltip>
                )}
              </TableCell>
            </React.Fragment>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export const TableHeadComponentSmallerText = ({
  titlesArray,
}: {
  titlesArray: any;
}) => {
  return (
    <TableHead>
      <TableRow>
        {titlesArray.map((title: any, index: number) => {
          return (
            <React.Fragment key={`${title}-${index}`}>
              <TableCell
                align="left"
                sx={{
                  fontFamily: "Mulish",
                  fontWeight: "Bold",
                  fontSize: "12px",
                }}
              >
                {title}
              </TableCell>
            </React.Fragment>
          );
        })}
      </TableRow>
    </TableHead>
  );
};
